import type { Option } from '@comparit/core';
import { Zahlungsweise } from '../../../interfaces';

export const zahlungsweiseOptions: Option<Zahlungsweise>[] = [
  { label: 'Jährlich', value: Zahlungsweise.Jaehrlich },
  { label: 'Halbjährlich', value: Zahlungsweise.Halbjaehrlich },
  { label: 'Vierteljährlich', value: Zahlungsweise.Vierteljaehrlich },
  { label: 'Monatlich', value: Zahlungsweise.Monatlich },
];
